import _ from "lodash";
import LZString from "lz-string";
import * as z from "../../../../framework";
import { ComboBox } from "../../components/comboBox";
import { Container, Grid } from "../../ui";
import { Widget } from "./widget";

// tslint:disable-next-line:variable-name
export var W_EditableGrid = function (widgetInstance?) {
    widgetInstance = widgetInstance || {};

    var widget = new Widget(widgetInstance);
    $.extend(this, widget);

    this.widgetId = widgetInstance.WidgetId,
    this.title = widgetInstance.title,
    this.type = widgetInstance.type,
    this.mainEntity = widgetInstance.mainEntity;
    this.entityType = widgetInstance.entityType || "";
    this.select = widgetInstance.select;
    this.expand = widgetInstance.expand;
    this.filter = widgetInstance.filter;
    this.columns = widgetInstance.columns;
    this.columnOrder = widgetInstance.columnOrder;
    this.orderBy = widgetInstance.orderBy;
    this.HTML = widgetInstance.HTML;

    this.divisions = widgetInstance.divisions === undefined
        ? true
        : widgetInstance.divisions;

    this.regions = widgetInstance.regions === undefined
        ? true
        : widgetInstance.regions;

    this.hideSearchOptions = widgetInstance.hideSearchOptions === undefined
        ? false
        : widgetInstance.hideSearchOptions;

    this.autoBind = widgetInstance.autoBind === undefined
        ? true
        : widgetInstance.autoBind;

    this.liveFilter = widgetInstance.liveFilter === undefined
        ? true
        : widgetInstance.liveFilter;

    this.divisionAndRegionOnly = widgetInstance.divisionAndRegionOnly === undefined
        ? false
        : widgetInstance.divisionAndRegionOnly;
};

W_EditableGrid.prototype = {
    initAsync: function () {
        var me = this,
            widgets = {},
            deferred = $.Deferred();

        var initEditableGrid = function (options) {
            me.widgetOptions = options.widgetOptions || {};
            me.gridOptions = options.gridOptions || {};
            me.jsonView = options.jsonView || {};
            var originalId = options.gridOptions.id;
            options.gridOptions.id = `WI${me.instanceId}_${(options.gridOptions.id || "EditableDataGrid")}`;

            var gridOptions = {
                id: options.gridOptions.id,
                type: options.type,
                title: options.title,
                entityType: options.gridOptions.entityTypes,
                mainEntity: options.gridOptions.mainEntity,
                stickyDefaultName: options.gridOptions.stickyDefaultName || me.widgetId,
                select: options.gridOptions.select,
                expand: options.gridOptions.expand,
                filter: options.gridOptions.filter,
                orderBy: options.gridOptions.orderBy,
                widgetName: options.widgetName,
                widgetType: options.widgetType,
                widgetId: `Widget_${originalId}`,
                columnOrder: options.gridOptions.columnOrder,
                columnRenames: options.gridOptions.columnRenames,
                url: "" + options.gridOptions.mainEntity,
                detailGrid: options.gridOptions.detailGrid,
                divisions: options.gridOptions.divisions,
                regions: options.gridOptions.regions
            };

            var btnSave = `</br><button id='${me.id}_EditableSave' class='action-button right'>Save</button>`;

            me.grid = me.contents.append(
                `<div style='padding-bottom:30px;'><div class='grid' id='${me.id}_EditableGrid'></div>${btnSave}</div>`).find(".grid");

            me.contents.unmask();
            var columnLayout = new Container({
                id: "EditableGridComposite",
                components: [
                    new Grid({
                        id: gridOptions.id,
                        stickyDefaultName: options.stickyDefaultName || gridOptions.widgetId
                    })
                ]
            });
            columnLayout.options.zScreen = me;
            columnLayout.render(me.grid);

            me.buildEditableGrid(gridOptions);
            deferred.resolve();
        };

        if (localStorage.Widgets) {
            widgets = $.parseJSON(LZString.decompressFromUTF16(localStorage.Widgets));
        }

        if (widgets[me.widgetId]) {
             initEditableGrid(widgets[me.widgetId]);
        } else {
            z.ajax({
                type: "GET",
                url: `Widget/?ID=${me.widgetId}`
            }).done(function (response) {
                var options = JSON.parse(response.d.results.Options);

                widgets[me.widgetId] = options;
                localStorage.setItem("Widgets", LZString.compressToUTF16(JSON.stringify(widgets)));

                initEditableGrid(options);
            });
        }
        return deferred.promise();
    },
    buildEditableGrid: function (options) {
        var me = this;

        me.acceptRejectCodeTable = "CallStatus";
        me.acceptCode = "ACCEPTED";
        me.rejectCode = "REJECTED";
        me.rejectOption = "";

        if (me.widgetOptions.AcceptOrRejectOptions) {
            me.acceptRejectCodeTable = me.widgetOptions.AcceptOrRejectOptions.AcceptRejectCodeTable;
            me.acceptCode = me.widgetOptions.AcceptOrRejectOptions.AcceptedStatus;
            me.rejectCode = me.widgetOptions.AcceptOrRejectOptions.RejectedStatus;
            me.rejectOption = me.widgetOptions.AcceptOrRejectOptions.RejectedOption;
        }

        var codeList = _.filter(z.codes[me.acceptRejectCodeTable], { IsDeleted: false } as {});
        $.each(codeList, function (index, c) {
            if (c.CodeNumber.toUpperCase() == me.acceptCode) {
                me.acceptedStatusId = c.Id;
            } else if (c.CodeNumber.toUpperCase() == me.rejectCode) {
                me.rejectedStatusId = c.Id;
            }
        });

        var rejectedCallResolutionId;
        var resolutionCodeList = _.filter(z.codes.CallResolution, { IsDeleted: false } as {});
        for (var ii = resolutionCodeList.length - 1; ii >= 0; ii--) {
            var code = resolutionCodeList[ii];
            if (code.CodeNumber.toUpperCase() == "REJECTED") {
                rejectedCallResolutionId = code.Id;
            }
        }

        // Komatsu does not have div or region, we can region and divisionify this later
        // if (z.user && z.user.companyData && z.user.companyData.DivisionAndRegionEnabled) {
        //     z.retrieveRegionAndDivisionFiltering(options);
        // }

        me.itemsAwaitingSave = [];

        var selectedIndex,
            gridColumns: any[] = [
                {
                    template:
                        `<div class='center'>
                               <div class='toggle-button accept-button grid-choice-button'>
                                   <span class='check accept-contract grid-choice-icon'/>
                               </div>
                               <div class='toggle-button reject-button grid-choice-button'>
                                   <span class='cancel reject-contract grid-choice-icon'/>
                               </div>
                            </div>`,
                    filterable: false,
                    width: 150
                }
            ];

        if (me.rejectOption) {
            gridColumns.push({
                field: me.rejectOption,
                title: z.ll(me.rejectOption),
                template: '<span class="reject-reason"></span>',
                width: "150px"
            });
        }

        var transformItem = function (item){
            if (me.widgetOptions.GridRowItemTransformations) {
                var transforms = me.widgetOptions.GridRowItemTransformations.split(".");

                for (var j = 0; j < transforms.length; j++) {
                    item = item[transforms[j]];
                }
                return item;
            }
            return item;
        };

        var grid = me.kendoGrid = z.controls.grid({
            id: options.id,
            zScreen: me,
            selectable: "row",
            autoBind: false,
            allowExcelExport: false,
            entityTypes: options.entityType,
            select: options.select,
            expand: options.expand,
            filter: options.filter,
            widgetId: options.widgetId,
            widget: true,
            regions: false,
            divisions: false,
            columnRenames: options.columnRenames,
            columnOrder: options.columnOrder,
            sort: options.orderBy,
            excelExport: function (e) {
                z.restoreExpr();
                $(`#${screenId}_WidgetContainer_PrintButton`).removeClass("disabled");
                me.contents.unmask();
            },
            detailInit: options.detailGrid ? function (e) {
                var detail = $("<div/>").appendTo(e.detailCell);
                var dataItem = e.data;
                options.detailGrid.divisions = false;
                options.detailGrid.regions = false;
                options.detailGrid.dataSource = dataItem.CallItem;
                options.detailGrid.gridObject = detail;
                var detailGrid = z.controls.grid(options.detailGrid);

                detailGrid.bind("change", function () {
                    var detailRow = detailGrid.select();
                    grid.tbody.find("tr").removeClass("k-state-selected");
                    detailRow.addClass("k-state-selected");
                    detailRow.parents("tr.k-detail-row").prev().addClass("k-state-selected");
                });
            } : null,
            columns: gridColumns,
            dataBound: function (e) {
                var data = this.dataSource.data();
                $.each(data, function (index, item) {
                    var row = me.get("#" + options.id).find('tr[data-uid="' + item.uid + '"]');
                    var acceptButton = row.find(".accept-button");
                    var rejectButton = row.find(".reject-button");
                    var rejectReason = $(row).find(".reject-reason");

                    item = transformItem(item);

                    var setAssignedTo = function (matchedIndex) {
                        if (me.widgetOptions.SetAssignedTo) {
                            me.itemsAwaitingSave[matchedIndex].AssignedToId = z.user.loginData.UserId;
                        }
                    },
                    setCallResolution = function (matchedIndex, toNull?) {
                        if (me.widgetOptions.SetCallResolution) {
                            me.itemsAwaitingSave[matchedIndex].CallResolutionId = toNull ? null : rejectedCallResolutionId;
                        }
                    },
                    setRejectOption = function (matchedIndex, rejectedOptionSelected) {
                        if (me.rejectOption) {
                            me.itemsAwaitingSave[matchedIndex][`${me.rejectOption}Id`] = rejectedOptionSelected;
                        }
                    };

                    var matchingIndex = _.findIndex(me.itemsAwaitingSave as any[], function (o) { return o.Id == item.Id; } );

                    if (matchingIndex > -1) {
                        item[`${me.acceptRejectCodeTable}Id`] = me.itemsAwaitingSave[matchingIndex][`${me.acceptRejectCodeTable}Id`];

                        if (me.rejectOption) {
                            item[`${me.rejectOption}Id`] = me.itemsAwaitingSave[matchingIndex][`${me.rejectOption}Id`];
                        }

                        if (me.widgetOptions.SetCallResolution) {
                            item.CallResolutionId = me.itemsAwaitingSave[matchingIndex].CallResolutionId;
                        }
                    }

                    if (item[`${me.acceptRejectCodeTable}Id`] == me.acceptedStatusId) {
                        acceptButton.addClass("button-down");
                        acceptButton.removeClass("button-up");
                        rejectButton.addClass("button-up");
                    } else if (item[`${me.acceptRejectCodeTable}Id`] == me.rejectedStatusId) {
                        rejectButton.addClass("button-down-rejected");
                        rejectButton.removeClass("button-up");
                        acceptButton.removeClass("button-down");
                        acceptButton.addClass("button-up");
                    }

                    var rejectOptionKcb;
                    if (me.rejectOption) {
                        rejectOptionKcb = setupRejectReasonComboBox({
                            rejectReason: rejectReason,
                            grid: grid,
                            row: row,
                            item: item
                        });
                    }

                    rejectButton.bind("click", function () {
                        selectedIndex = index;
                        acceptButton.removeClass("button-down");
                        acceptButton.addClass("button-up");

                        if (item[`${me.acceptRejectCodeTable}Id`] == me.acceptedStatusId || item[`${me.acceptRejectCodeTable}Id`] != me.rejectedStatusId) {
                            item[`${me.acceptRejectCodeTable}Id`] = me.rejectedStatusId;
                            rejectButton.addClass("button-down-rejected");
                            rejectButton.removeClass("button-up");
                            rejectReason.removeClass("hidden");
                        } else {
                            item[me.acceptRejectCodeTable + "Id"] = null;
                            rejectButton.removeClass("button-down-rejected");
                            rejectButton.removeClass("button-up");
                            rejectReason.addClass("hidden");
                        }

                        var matchedIndex = _.findIndex(me.itemsAwaitingSave as any[], function (o) { return o.Id == item.Id; } );

                        if (me.itemsAwaitingSave.length > 0 && matchedIndex > -1) {
                            if (item[`${me.acceptRejectCodeTable}Id`]) {
                                me.itemsAwaitingSave[matchedIndex][`${me.acceptRejectCodeTable}Id`] = me.rejectedStatusId;

                                rejectOptionKcb && rejectOptionKcb.trigger("change");
                                setAssignedTo(matchedIndex);
                                setCallResolution(matchedIndex);
                            } else {
                                me.itemsAwaitingSave.splice(matchedIndex, 1);
                            }
                        } else {
                            item[`${me.acceptRejectCodeTable}Id`] = me.rejectedStatusId;
                            me.itemsAwaitingSave.push(item);

                            rejectOptionKcb && rejectOptionKcb.trigger("change");
                            setAssignedTo(me.itemsAwaitingSave.length - 1);
                            setCallResolution(me.itemsAwaitingSave.length - 1);
                        }
                    });

                    acceptButton.bind("click", function () {
                        selectedIndex = index;
                        rejectButton.addClass("button-up");
                        rejectButton.removeClass("button-down-rejected");

                        if (item[`${me.acceptRejectCodeTable}Id`] == me.rejectedStatusId || item[`${me.acceptRejectCodeTable}Id`] != me.acceptedStatusId) {
                            item[`${me.acceptRejectCodeTable}Id`] = me.acceptedStatusId;
                            acceptButton.addClass("button-down");
                            acceptButton.removeClass("button-up");
                            rejectReason.addClass("hidden");
                        } else {
                            item[`${me.acceptRejectCodeTable}Id`] = null;
                            acceptButton.removeClass("button-down");
                            acceptButton.addClass("button-up");
                        }

                        var matchedIndex = _.findIndex(me.itemsAwaitingSave as any[], function (o) { return o.Id == item.Id; } );

                        if (me.itemsAwaitingSave.length > 0 && matchedIndex > -1) {
                            if (item[`${me.acceptRejectCodeTable}Id`]) {
                                me.itemsAwaitingSave[matchedIndex][`${me.acceptRejectCodeTable}Id`] = me.acceptedStatusId;

                                setRejectOption(matchedIndex, null);
                                setCallResolution(matchedIndex, true);
                                setAssignedTo(matchedIndex);
                            } else {
                                me.itemsAwaitingSave.splice(matchedIndex, 1);
                            }

                        } else {
                            item[`${me.acceptRejectCodeTable}Id`] = me.acceptedStatusId;
                            me.itemsAwaitingSave.push(item);

                            setRejectOption(me.itemsAwaitingSave.length - 1, null);
                            setCallResolution(me.itemsAwaitingSave.length - 1, true);
                            setAssignedTo(me.itemsAwaitingSave.length - 1);
                        }
                    });

                    if (!selectedIndex) {
                        grid.select(e.sender.tbody.find("tr:eq(0)"));
                    } else {
                        grid.select(e.sender.tbody.find(`tr:eq(${selectedIndex})`));
                    }
                });
            }
        });

        var screenIndx = this.screenId.indexOf("_");
        var screenId = this.screenId.substr(0, screenIndx);
        let printButton = $(`#${screenId}_WidgetContainer_PrintButton`);

        printButton.off().tie("click", function () {
            printButton.addClass("disabled");
            me.contents.mask();

            z.setExprAlwaysSafe();
            let kendoGrid = $(`#${me.id}_${options.id}`).data("kendoGrid");
            kendoGrid.options.excel.fileName = me.widgetName + " Export.xlsx";
            kendoGrid.saveAsExcel();
        });

        $(`#${options.Id}_filterDataButton`).off().tie("click", function () {
            me.get(`#${options.id}`).data("kendoGrid").dataSource.read();
        });
        me.get(`#${options.id}`).data("kendoGrid").dataSource.read();

        me.get("#EditableSave").tie("click", function () {
            me.acceptOrRejectItems();
        });

        var setupRejectReasonComboBox = function (localArgs) {
            var rejectReason = localArgs.rejectReason,
                theGrid = localArgs.grid,
                row = localArgs.row,
                item = localArgs.item;

            var comboBox = new ComboBox({
                bsc: " ",
                classes: "long-input",
                systemCode: true
            });

            comboBox.render($(rejectReason));
            rejectReason.addClass("hidden");
            var kcb = $(`#${comboBox.id}`).data("kendoComboBox");
            if (kcb) {
                var comboIndex,
                    found = false;
                var theCodeList = z.codes[me.rejectOption];
                var matchedIndex = _.findIndex(me.itemsAwaitingSave as any[], function (o) { return o.Id == item.Id; } );
                kcb.setDataSource(theCodeList as any);
                $.each(theCodeList, function (ind, data) {
                    if (data.Id == item[`${me.rejectOption}Id`]) {
                        comboIndex = ind;
                        kcb.select(comboIndex);
                        if (matchedIndex > -1) {
                            me.itemsAwaitingSave[matchedIndex][`${me.rejectOption}Id`] = data.Id;
                            rejectReason.removeClass("hidden");
                        }
                        found = true;
                        return false;
                    }
                    return true;
                });

                if (!found) {
                    kcb.select(1);
                    if (matchedIndex > -1) {
                        me.itemsAwaitingSave[matchedIndex][`${me.rejectOption}Id`] = theCodeList[1].Id;
                    }
                }

                kcb.bind("change", function (ev) {
                    if (ev.sender.value() > -1) {
                        var theMatchedIndex = _.findIndex(me.itemsAwaitingSave as any[], function (o) { return o.Id == item.Id; } );
                        if (theMatchedIndex > -1) {
                            me.itemsAwaitingSave[theMatchedIndex][`${me.rejectOption}Id`] = ev.sender.value();
                        }
                    }
                });

                kcb.bind("open", function (ev) {
                    theGrid.select(row);
                });
            }

            return kcb;
        };
    },
    acceptOrRejectItems: function () {
        var me = this;

        me.grid.mask();
        var successCount = 0,
            ajaxCalls = [],
            numberArray = [],
            entity = "Call";

        $.each(me.itemsAwaitingSave, function (index, data) {
            if (data) {
                var dto: any = {};

                if (me.widgetOptions.DTOMap) {
                    $.each(me.widgetOptions.DTOMap, function (i, mapping){
                        dto[mapping.To] = data[mapping.From];
                    });

                    if (me.widgetOptions.DTOAdditionalValues) {
                        $.each(me.widgetOptions.DTOAdditionalValues, function (i, additionalValue){
                            dto[additionalValue.To] = additionalValue.Value;
                        });
                    }
                } else {
                    dto = {
                        Id: data.Id,
                        CallStatusId: data[`${me.acceptRejectCodeTable}Id`],
                        AssignedToId: data.AssignedToId
                    };
                }

                if (me.rejectOption) {
                    dto[`${me.rejectOption}Id`] = data[`${me.rejectOption}Id`];
                }

                var ajaxCall;
                if (me.widgetOptions.AjaxOptions) {
                    ajaxCall = z.ajax({
                        type: me.widgetOptions.AjaxOptions.Type,
                        url: me.widgetOptions.AjaxOptions.URL,
                        data: dto
                    }).done(function () {
                        successCount++;
                        if (me.widgetOptions.AjaxOptions.SuccessNumber) {
                            numberArray.push(data[me.widgetOptions.AjaxOptions.SuccessNumber]);
                        }
                    });
                    entity = me.widgetOptions.AjaxOptions.Entity || "Call";
                } else {
                    ajaxCall = z.ajax({
                        type: "PATCH",
                        url: "Call",
                        data: dto
                    }).done(function () {
                        successCount++;
                        numberArray.push(data.CallNumber);
                        if (data.CallResolutionId) {
                            z.ajax({
                                type: "POST",
                                url: `call/finalize?id=${dto.Id}`,
                                data: null
                            }).done(function () {
                                z.ajax({
                                    type: "POST",
                                    url: `call/close?id=${dto.Id}&resolutionId=${data.CallResolutionId}`,
                                    data: null
                                }).done(function () {

                                }).fail(function () {

                                });
                            }).fail(function () {

                            });
                        }
                    });
                }

                ajaxCalls.push(ajaxCall);
            }
        });

        $.whenAll(ajaxCalls)
            .always(function () {
                if (successCount > 0) {
                    z.controls.alert({
                        type: "success",
                        header: z.ll("SaveSuccessful"),
                        message: `${z.ll(entity)} ${z.ll("SaveSuccessfulMessage").format(numberArray.toString())}`
                    });
                    me.itemsAwaitingSave = [];
                    me.kendoGrid.zRefresh();
                }
                me.grid.unmask();
            });
    }
};
